import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MapPin, BedDouble, Bath, Maximize, ArrowLeft, MessageCircle, Phone, User } from "lucide-react";
import { Navbar, Footer } from "@/components/Navbar";
import { ContactButton } from "@/components/ContactButton";
import api from "@/lib/api";

export default function RentalDetail() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [active, setActive] = useState(0);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => { api.get(`/rentals/${id}`).then((res) => setR(res.data)).catch(() => setNotFound(true)); }, [id]);

  if (notFound) return <div className="min-h-screen bg-[#fafaf8]"><Navbar /><div className="max-w-3xl mx-auto px-4 py-24 text-center text-[#78716c]">Imóvel não encontrado.</div></div>;
  if (!r) return <div className="min-h-screen bg-[#fafaf8]"><Navbar /><div className="max-w-3xl mx-auto px-4 py-24 text-center text-[#78716c]">Carregando...</div></div>;

  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/alugueis" className="inline-flex items-center gap-2 text-sm text-[#78716c] hover:text-[#1b5e3f] mb-6"><ArrowLeft className="w-4 h-4" /> Voltar aos aluguéis</Link>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden bg-[#e8f0ec] aspect-[16/10]">
              {r.photos?.[active] ? <img src={r.photos[active]} alt={r.title} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-[#1b5e3f]/40">Sem foto</div>}
            </div>
            {r.photos?.length > 1 && (
              <div className="flex gap-3 mt-3 overflow-x-auto scrollbar-hide">
                {r.photos.map((ph, i) => (
                  <button key={i} onClick={() => setActive(i)} className={`w-24 h-20 rounded-xl overflow-hidden shrink-0 border-2 ${active === i ? "border-[#1b5e3f]" : "border-transparent"}`}>
                    <img src={ph} alt="" className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            )}

            <div className="mt-8">
              <h2 className="font-head text-lg font-semibold text-[#1c1917]">Descrição</h2>
              <p className="text-[#78716c] mt-2 leading-relaxed whitespace-pre-line">{r.description || "Sem descrição."}</p>
            </div>
          </div>

          <aside className="lg:col-span-1">
            <div className="bg-white rounded-2xl border border-[#e7e5e4] shadow-sm p-6 lg:sticky lg:top-24">
              <span className="bg-[#fef3c7] text-[#d97706] px-3 py-1 rounded-full text-xs font-semibold">{r.type}</span>
              <h1 className="font-head text-2xl font-bold text-[#1c1917] mt-3" data-testid="rental-title">{r.title}</h1>
              <div className="flex items-center gap-1 text-sm text-[#78716c] mt-2"><MapPin className="w-4 h-4" /> {r.city}, {r.region}</div>
              <div className="font-head text-3xl font-bold text-[#1b5e3f] mt-4">€{Number(r.price).toLocaleString("pt-PT")}<span className="text-base font-normal text-[#78716c]">/mês</span></div>

              <div className="grid grid-cols-3 gap-2 mt-5 text-center">
                <div className="bg-[#fafaf8] rounded-xl py-3"><BedDouble className="w-4 h-4 mx-auto text-[#1b5e3f]" /><span className="text-sm text-[#1c1917] block mt-1">{r.bedrooms} qts</span></div>
                <div className="bg-[#fafaf8] rounded-xl py-3"><Bath className="w-4 h-4 mx-auto text-[#1b5e3f]" /><span className="text-sm text-[#1c1917] block mt-1">{r.bathrooms} WC</span></div>
                <div className="bg-[#fafaf8] rounded-xl py-3"><Maximize className="w-4 h-4 mx-auto text-[#1b5e3f]" /><span className="text-sm text-[#1c1917] block mt-1">{r.area || "-"} m²</span></div>
              </div>

              <div className="border-t border-[#e7e5e4] mt-6 pt-5">
                <div className="flex items-center gap-2 text-[#1c1917] font-medium"><User className="w-4 h-4 text-[#1b5e3f]" /> {r.owner?.name}</div>
                <div className="mt-3"><ContactButton contextType="rental" contextId={r.id} /></div>
                {r.owner?.whatsapp && <a data-testid="rental-whatsapp" href={`https://wa.me/${r.owner.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="mt-3 w-full inline-flex items-center justify-center gap-2 bg-white border border-[#1b5e3f] text-[#1b5e3f] hover:bg-[#e8f0ec] rounded-xl py-3 text-sm font-medium transition-colors"><MessageCircle className="w-4 h-4" /> Contatar via WhatsApp</a>}
                {r.owner?.phone && <div className="flex items-center gap-2 text-sm text-[#78716c] mt-3"><Phone className="w-4 h-4" /> {r.owner.phone}</div>}
              </div>
            </div>
          </aside>
        </div>
      </div>
      <Footer />
    </div>
  );
}
